import { render, staticRenderFns } from "./add.vue?vue&type=template&id=0013280c&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0013280c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0013280c')) {
      api.createRecord('0013280c', component.options)
    } else {
      api.reload('0013280c', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=0013280c&scoped=true&", function () {
      api.rerender('0013280c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rate/add.vue"
export default component.exports